module.exports = __webpack_public_path__ + "161a19990ea21cfd8e44ee2b192efaef.jpg";